import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { UserLoginGQL } from './user-login.graphql';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { ToastrService } from 'ngx-toastr';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-user-login',
  templateUrl: './user-login.component.html',
  styleUrls: ['./user-login.component.scss']
})
export class UserLoginComponent implements OnInit {
  loginForm: UntypedFormGroup;
  loginBtnLoading: boolean = false;

  constructor(
    private userLogin: UserLoginGQL, 
    private router: Router, 
    fb: UntypedFormBuilder,
    private authService: AuthService,
    private toastr: ToastrService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.loginForm = fb.group({
      email: new UntypedFormControl(null, Validators.required),
      password: new UntypedFormControl(null, Validators.required)
    });
  }

  ngOnInit(): void { }

  onLoginSubmit() {
    this.loginBtnLoading = true;
    this.userLogin
      .fetch({
        ...this.loginForm.value,
        options: {
          fetchPolicy: 'network-only'
        }
      }
      ).subscribe(({ data }) => {
        if (isPlatformBrowser(this.platformId)) {
          localStorage.setItem('token', data.login.token);
          localStorage.setItem('email', data.login.email);
        }
        this.loginBtnLoading = false;
        this.toastr.success('Sucessfuly logged in!', null, {
          timeOut: 3000,
        });
        this.router.navigate(['./loyalty']);
        this.authService.isLoggedInSubject.next(true);
      }, err => {
        this.loginBtnLoading = false;
        this.toastr.error(err.message, null, {
          timeOut: 5000,
        });
      });
  }
}
